/**
 * API 경로 상수
 * 환경별 API 경로 변경이 필요한 경우 이 파일에서 관리
 */

// Base Prefixes
export const API_PREFIX = {
  AUTH: '/auth',
  USER: '/users',
  COMMUNITY: '/communities',
  ARTIST: '/artists',
  SERIES:'/series',
  EPISODE: '/episodes',
  NOTICE: '/notices',
  DUBRIGHT: '/dubright',
  EVENT: '/events',
  CURATOR:'/curators',
  BANNER: '/heroes',
  TAG:'/tags',
  LOOKUP:'/look-ups',
  POLICY:'/policies',
  FAQ:'/faqs',
  INQUIRY:'/inquiries',
  PAYMENT: '/payment',
  BONUS: '/bonus/coins',
  PURCHASE: '/purchases',
  TICKET: '/tickets',
  FORBIDDEN: '/forbidden-words',
  FANCOMMENT: '/fan-comments',
  CONTENTCOMMENT: '/series-comments',
  ALBUMCOMMENT: '/album-comments',
  POPUP: '/popups',
  ADMIN: '/members',
  CASTING: '/casting',
  PLAYER: '/player',
  JOB: '/jobs',
  LOG:'/change-logs',
  ALBUM:'/albums',
  MUSIC:'/music',
  SETTLEMENT: '/settlement',
} as const

// Auth API
export const AUTH_API = {
  LOGIN: `${API_PREFIX.AUTH}/sign-in`,
  REFRESH: '/reissue',
  NAVER_WORKS: `${API_PREFIX.AUTH}/naver-works/sign-in`,
  SELF: `/self`,
  PASSWORD_RESET_CODE: `${API_PREFIX.AUTH}/password-reset/verification-code`,
  PASSWORD_RESET_CODE_VERIFY: `${API_PREFIX.AUTH}/password-reset/verification-code/verify`,
  PASSWORD_RESET: `${API_PREFIX.AUTH}/password-reset`,

} as const

//관리자
export const ADMIN_API = {
  PREFIX: API_PREFIX.ADMIN,
  ID: (id: string | number) => `${API_PREFIX.ADMIN}/${id}`,
} as const

// 사용자 - 유저
export const USER_API = {
  PREFIX: API_PREFIX.USER,
  ID: (id: string | number) => `${API_PREFIX.USER}/${id}`,
} as const

// 사용자 - 아티스트
export const ARTIST_API = {
  PREFIX: API_PREFIX.ARTIST,
  ID: (id: string | number) => `${API_PREFIX.ARTIST}/${id}`,
} as const

// 콘텐츠 - 보이스툰
export const SERIES_API = {
  PREFIX: API_PREFIX.SERIES,
  ID: (id: string | number) => `${SERIES_API.PREFIX}/${id}`,

  // Characters
  CHARACTERS: (seriesId: string | number) => `${SERIES_API.ID(seriesId)}/characters`,
  CHARACTER_ID: (seriesId: string | number, characterId: string | number) =>
    `${SERIES_API.CHARACTERS(seriesId)}/${characterId}`,

  // Castings
  CASTINGS: (seriesId: string | number, characterId: string | number) =>
    `${SERIES_API.CHARACTER_ID(seriesId, characterId)}/castings`,
  CASTING_ID: (seriesId: string | number, characterId: string | number, castingId: string | number) =>
    `${SERIES_API.CASTINGS(seriesId, characterId)}/${castingId}`,

  // Notices
  NOTICES: (seriesId: string | number) => `${SERIES_API.ID(seriesId)}/notices`,
  NOTICE_ID: (seriesId: string | number, noticeId: string | number) =>
    `${SERIES_API.NOTICES(seriesId)}/${noticeId}`,

  // 기존 특수 케이스들
  SERIES_CASTING: `/casting/series`,
  REGISTER_CASTING: (seriesId: number | string) =>
                  `${API_PREFIX.SERIES}/${seriesId}/castings`
} as const

// 콘텐츠 - 에피소드
export const EPISODE_API = {
  PREFIX: API_PREFIX.EPISODE,
  ID: (id: number | string) =>  `${API_PREFIX.EPISODE}/${id}`,
  EPISODE_CASTING: `/casting/archive/episode`,
  EPISODE_UPDATECASTING: (episodeId: number | string) =>
    `/casting/archive/episode/${episodeId}`,
  REGISTER_CASTING: (episodeId: number | string) => 
                    `${API_PREFIX.EPISODE}/${episodeId}/castings`,
  INSPECTION: (episodeId: number | string) => 
                    `${API_PREFIX.EPISODE}/${episodeId}/inspection`
} as const

// 콘텐츠 - 앨범
export const ALBUM_API = {
  PREFIX: API_PREFIX.ALBUM,
  ID: (id: string | number) => `${API_PREFIX.ALBUM}/${id}`,
  OPEN: (id: string | number) => `${API_PREFIX.ALBUM}/${id}/open`,
} as const

//콘텐츠 - 수록곡
export const MUSIC_API ={
  PREFIX:API_PREFIX.MUSIC,
  ID: (id: string | number) => `${API_PREFIX.MUSIC}/${id}`,
} as const

// 이벤트
export const EVENT_API = {
  PREFIX: API_PREFIX.EVENT,
  ID: (id: string | number) => `${API_PREFIX.EVENT}/${id}`,
} as const

// 유저지원 - 온라인 문의
export const INQUIRY_API = {
  PREFIX: API_PREFIX.INQUIRY,
  ID: (id: string | number) => `${API_PREFIX.INQUIRY}/${id}`,
  ANSWERS: (id: string | number) => `${API_PREFIX.INQUIRY}/${id}/answers`,
} as const

// 유저지원 - 공지사항
export const NOTICE_API = {
  PREFIX: API_PREFIX.NOTICE,
  ID: (id: string | number) => `${API_PREFIX.NOTICE}/${id}`,
} as const
// 유저지원- FAQ
export const FAQ_API = {
  PREFIX: API_PREFIX.FAQ,
  ID: (id: string | number) => `${API_PREFIX.FAQ}/${id}`,
} as const

//  커뮤니티 - 게시판
export const COMMUNITY_API = {
    PREFIX: API_PREFIX.COMMUNITY,
    COMMENT: `${API_PREFIX.COMMUNITY}/comments`,
    ID: (id: string | number) => `${API_PREFIX.COMMUNITY}/${id}`,
    COMMENT_DELETE : (id: number | string) =>`${COMMUNITY_API.COMMENT}/${id}`
} as const

//  커뮤니티 - 팬보드
export const FANCOMMENT_API = {
  PREFIX: API_PREFIX.FANCOMMENT,
  ID: (id: string | number) => `${API_PREFIX.FANCOMMENT}/${id}`,
} as const

//  커뮤니티 - 콘텐츠 댓글
export const CONTENTCOMMENT_API = {
  PREFIX: API_PREFIX.CONTENTCOMMENT,
  DELETE: (id: string | number) => `${API_PREFIX.CONTENTCOMMENT}/${id}/block`,
} as const

//  커뮤니티 - 콘텐츠 댓글
export const ALBUMCOMMENT_API = {
  PREFIX: API_PREFIX.ALBUMCOMMENT,
  DELETE: (id: string | number) => `${API_PREFIX.ALBUMCOMMENT}/${id}/block`,
} as const


//  커뮤니티 -금칙어
export const FORBIDDEN_API = {
  PREFIX: API_PREFIX.FORBIDDEN,
  ID: (id: string | number) => `${API_PREFIX.FORBIDDEN}/${id}`,
} as const


//결제 및 구매
export  const PAYMENT_API = {
  PREFIX: API_PREFIX.PAYMENT,
  REFUND_ID: (id: string | number) => `${PAYMENT_API.PREFIX}/refund/${id}`,
} as const

export const BONUS_API = {
  PREFIX: API_PREFIX.BONUS,
  CANCEL: (id: string | number) => `${BONUS_API.PREFIX}/${id}/cancel`,
} as const

//화면 - 배너
export const BANNER_API = {
  PREFIX: API_PREFIX.BANNER,
  ID: (id: string | number) => `${BANNER_API.PREFIX}/${id}`,
  ITEM_LIST: (id: string | number) => `${BANNER_API.PREFIX}/${id}/items`,
  ITEM_ID: (id: string | number, itemId:string | number) => `${BANNER_API.PREFIX}/${id}/items/${itemId}`,
  SEQUENCE: (id: string | number) => `${BANNER_API.PREFIX}/${id}/sequences`,
} as const

// 화면 - 섹션
export const CURATOR_API = {
  PREFIX: API_PREFIX.CURATOR,
  ID: (id: string | number) => `${API_PREFIX.CURATOR}/${id}`,
  ITEMS: (id: string | number) => `${CURATOR_API.ID(id)}/items`,
  ITEM_ID: (id: string | number, itemId: string | number) => `${CURATOR_API.ITEMS(id)}/${itemId}`,

} as const

// 화면 - 팝업
export const POPUP_API = {
  PREFIX: API_PREFIX.POPUP,
  ID: (id: string | number) => `${API_PREFIX.POPUP}/${id}`,
} as const

//판매 정책
export const POLICY_API = {
  PREFIX: API_PREFIX.POLICY,
  CONTENTPRICE: `${API_PREFIX.POLICY}/content-prices`,
  BONUS: `/bonus/coin${API_PREFIX.POLICY}`,
  COIN: `${API_PREFIX.POLICY}/coins`,
  BASIC: `${API_PREFIX.POLICY}/settlements`,
} as const

// 태그
export const TAG_API = {
  PREFIX: API_PREFIX.TAG,
  ID: (id: string | number) => `${API_PREFIX.TAG}/${id}`,
} as const

// 코드
export const LOOKUP_API = {
  PREFIX: API_PREFIX.LOOKUP,
  ID: (id: string | number) => `${API_PREFIX.LOOKUP}/${id}`,
} as const


// DUBRIGHT_API
export const DUBRIGHT_API = {
  PREFIX: API_PREFIX.DUBRIGHT,
  META: `${API_PREFIX.DUBRIGHT}/metadata`,
  RESOURCE: `${API_PREFIX.DUBRIGHT}/resource`,
  // 검수 데이터 조회 엔드포인트
  INSPECTION: (archiveId: number | string) =>
    `${API_PREFIX.DUBRIGHT}/resource/tracks-holes-records/${archiveId}`,
} as const

export const PREVIEW_API = {
  GENERATE_KEY: `${API_PREFIX.PLAYER}/generate/temp-token`,
  KEY_INFO: `${API_PREFIX.PLAYER}/info/temp`
} as const


//스케줄러
export const JOB_API = {
  PREFIX: API_PREFIX.JOB,
} as const

//수정기록
export const LOG_API = {
  PREFIX: API_PREFIX.LOG,
} as const

//정산
export const SETTLEMENT_API = {
  PREFIX: API_PREFIX.SETTLEMENT,
  PURCHASE_LIST: '/purchase/list',
  ARTIST_EXPORT: `${API_PREFIX.SETTLEMENT}/export`,
  PURCHASE_EXPORT: '/purchase/list/export',
  HISTORY: `${API_PREFIX.SETTLEMENT}/download/history`,
  LIST_EXPORT: `${API_PREFIX.SETTLEMENT}/list/export`,
  LIST_EPISODE: `${API_PREFIX.SETTLEMENT}/list/episode`,
  LIST_SERIES: `${API_PREFIX.SETTLEMENT}/list/series`,
} as const